// Avatar-URLs werden API-relativ gespeichert (`/avatars/<userId>?v=...`).
// Im Browser müssen sie gegen die API-Base aufgelöst werden (Dev: /api-Proxy,
// Prod: VITE_API_BASE_URL). Absolute URLs + leere Werte bleiben unverändert.

import { getApiBase } from './api';

export function resolveAvatarUrl(avatarUrl: string | null | undefined): string {
  if (!avatarUrl) return '';
  if (avatarUrl.startsWith('http') || avatarUrl.startsWith('data:')) return avatarUrl;
  if (avatarUrl.startsWith('/avatars/')) return `${getApiBase()}${avatarUrl}`;
  return avatarUrl;
}
